import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {auth} from '../FirebaseConfig';

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const history = useHistory();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((authUser) => {
            if (authUser){
                //user has logged in
                setUser(authUser);
                history.push('/');
            }
            else{
                //user has logged out
                setUser(null);
            }
        });
        return () => {
            unsubscribe(); //cleanup
        }
    }, [user]);

    return (
        <AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>
    );
};